export class BlueBank {
  moneyOrigen: string = "";
  employer: boolean = false;
  // step 1
  termAndConditions: boolean;

  isSitizen: string;
  isValid: boolean;

  //step 2
  countrySelect: any;
  countryIdRes: string;
  stateIdRes: string;
  cityRes: string = "";
  addressRes: string = "";
  countryOfBirthId: null;
  // stateOfBirth: string;
  cityOfBirth: string;
  maritalStatusId: null;
  nationalityId: null;
  doubleNationality: boolean;
  otherNationalityId: null;
  occupationId: null;
  economicActivityId: null;
  professionId: null;
  //step 3
  //Employer Information
  employerName: string;
  callingCode: string = "";
  employerTelephone: string;
  employerCountryId: string;
  employerState: string;
  employerCity: string;
  employerAddress: string;
  companyWebPage: string;
  bussinessEmail: string;
  //financial Information
  monthly_income: string = "";
  other_annual_income: string = "";
  description_annual_income: string = "";
  country: string = "";
  type_of_reference_document: string = "";
  tax_reference_number: string = "";
  //transactional Profile
  initialDeposit: number;
  monthlyDeposits: any;
  totalMonthlyDeposits: any;
  monthlyWithdraws: any;
  totalMonthlyWithdraws: any;

  //step 4
  currencyAccount: string = "";
  mainCurrency: string = "";
  secondCurrency: string = "";
  fundsOriginId: string = "";
  bothCurrencies: boolean;
  //step 5
  politicallyExposed: boolean;
  optionPep = "";
  relationshipId: number;
  nameTitle: string = "";
  functionLevel: string = "";
  dateBecame: string = "";
  dateStopped: string = "";
  datBecameYear: any;
  datBecameMounth: any;
  datBecameDay: any;
  dateStoppedYear: any;
  dateStoppedMounth: any;
  dateStoppedDay: any;
  relationship: string = "";
  //step 6

  doc1: boolean = false;
  doc1FileName: string = "";
  doc2: boolean = false;
  doc2FileName: string = "";
  termsConditions: boolean = false;
  termsConditionsIp: string = "";
}
